import { addSelectedFiltersToQuery } from 'src/utils/utils';
import { request } from '../api';

export type DeviceNavTab = 'panels' | 'groups' | 'connections';

export interface DeviceNavChild {
  id: string;
  tag: string;
  kind: 'controller' | 'standaloneCircuit';
  childCount: number;
}

export interface DeviceNavNode {
  /** A panel, group or comm loop id; 'other' for devices with no panel or comm loop. */
  id: string;
  tag: string | null;
  children: DeviceNavChild[];
}

export interface DeviceNavResponse {
  by: DeviceNavTab;
  total: number;
  items: DeviceNavNode[];
}

export const getDeviceNav = (action, { tab, selectedFilters }: { tab: DeviceNavTab; selectedFilters: any }): Promise<DeviceNavResponse> =>
  request(action, {
    payload: {
      url: '/eht-controllers/list/breakdown',
      query: addSelectedFiltersToQuery(selectedFilters, { by: tab }),
      options: { method: 'GET' }
    },
    normalize: (data) => data.toJS()
  });
